module.exports = __webpack_public_path__ + "img/CAN.8d4a7e85.svg";